import { motion } from 'framer-motion';

export default function Termini() {
  return (
    <div className="bg-ivory pt-32 min-h-screen" data-testid="termini-page">
      <section className="pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <motion.p
            className="font-body text-xs uppercase tracking-[0.3em] text-champagne mb-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            Legale
          </motion.p>
          <motion.h1
            className="font-heading text-4xl md:text-5xl text-night tracking-tight mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            data-testid="page-title"
          >
            Termini e Condizioni
          </motion.h1>
          
          <div className="prose prose-stone max-w-none">
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">1. Accettazione dei Termini</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Utilizzando il sito web lavillapool.it e i servizi offerti da La Villa S.r.l., accetti integralmente i presenti Termini e Condizioni. Se non accetti questi termini, ti preghiamo di non utilizzare il nostro sito.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">2. Servizi Offerti</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              La Villa offre:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Accesso giornaliero alla piscina e alle strutture</li>
              <li>Organizzazione di eventi privati</li>
              <li>Serate ed eventi speciali</li>
              <li>Vendita di articoli brandizzati</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">3. Prenotazioni e Pagamenti</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Le prenotazioni sono soggette a disponibilità. I pagamenti devono essere effettuati al momento della prenotazione online o all'ingresso della struttura. Accettiamo:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Carte di credito/debito (Visa, Mastercard, American Express)</li>
              <li>Pagamenti contactless</li>
              <li>Bonifico bancario (solo per eventi)</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">4. Cancellazioni e Rimborsi</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              <strong>Ingressi giornalieri:</strong> Cancellazione gratuita fino a 48 ore prima. Cancellazioni entro 24 ore: voucher del valore dell'importo.<br />
              <strong>Eventi privati:</strong> Cancellazione gratuita fino a 14 giorni prima. Tra 14 e 7 giorni: rimborso del 50%. Meno di 7 giorni: nessun rimborso.<br />
              <strong>Shop:</strong> Reso entro 30 giorni con prodotto integro.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">5. Regole della Struttura</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Tutti gli ospiti devono rispettare le seguenti regole:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Accesso riservato ai maggiorenni (salvo eccezioni)</li>
              <li>Dress code appropriato</li>
              <li>Divieto di introdurre cibo e bevande</li>
              <li>Divieto di fumo a bordo piscina</li>
              <li>Rispetto delle norme di sicurezza</li>
              <li>Comportamento rispettoso verso staff e altri ospiti</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">6. Responsabilità</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              La Villa declina ogni responsabilità per oggetti smarriti, furti o danni a oggetti personali. Si raccomanda l'utilizzo degli armadietti disponibili. La Villa non è responsabile per infortuni derivanti dal mancato rispetto delle regole di sicurezza.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">7. Proprietà Intellettuale</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Tutti i contenuti del sito (testi, immagini, logo, design) sono di proprietà di La Villa S.r.l. e sono protetti dalle leggi sul diritto d'autore. È vietata la riproduzione senza autorizzazione scritta.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">8. Condizioni Shop</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Per gli acquisti online:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>I prezzi sono IVA inclusa</li>
              <li>Spedizione gratuita sopra €100</li>
              <li>Diritto di recesso entro 14 giorni</li>
              <li>Reso entro 30 giorni per cambio taglia</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">9. Legge Applicabile</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia sarà competente il Foro di Modena.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">10. Contatti</h2>
            <p className="font-body text-stone-600 leading-relaxed">
              Per domande sui Termini e Condizioni: info@lavillapool.it
            </p>
          </div>
        </div>
      </section>

      <div className="h-20 lg:hidden" />
    </div>
  );
}
